import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IClassroomAssignmentDayUnitListItemDTO } from '@app/infrastructure/models/classroom-assignment';
import { IGradeUnitListItemDTO } from '@app/infrastructure/models/grade-unit/grade-unit';

@Component({
  selector: 'app-shared-grade-unit-day-list-presentation',
  templateUrl: './grade-unit-day-list-presentation.component.html',
  styleUrls: ['./grade-unit-day-list-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedGradeUnitDayListPresentationComponent {
  @Input() gradeUnitListItem: IGradeUnitListItemDTO;
  @Input() days: IClassroomAssignmentDayUnitListItemDTO[];
  @Input() unitNumber: number;
  @Input() gradeNumber: string;
  @Output() refresh: EventEmitter<boolean> = new EventEmitter();

  displayActions: boolean = false;

  onRefresh(event) {
    this.refresh.emit(true);
  }

  byId(index, item) {
    return item.id;
  }
}
